module.exports = __webpack_public_path__ + "static/img/wall.69e3aa7d.png";